module.exports = __webpack_public_path__ + "static/media/tracking-page-2.24049570.png";